import { useState } from "react";

const useDialog = () => {
    const [open, setOpen] = useState(false);

    const toggle = (bool) => {
        return setOpen(bool);
    };

    const closeDialog = () => {
        return setOpen(false);
    };

    const openDialog = () => {
        return setOpen(true);
    };

    return [open, toggle, openDialog, closeDialog];
};

export default useDialog;
